var AuthType;
(function (AuthType) {
  AuthType["EmailPassword"] = "EmailPassword";
  AuthType["Facebook"] = "Facebook";
  AuthType["Google"] = "Google";
})(AuthType || (AuthType = {}));
var MiscUtils = /** @class */function () {
  function MiscUtils() {}
  Object.defineProperty(MiscUtils, "isServer", {
    get: function () {
      return typeof window === 'undefined';
    },
    enumerable: false,
    configurable: true
  });
  MiscUtils.matchWidth = function (query, value, ssrResult) {
    if (ssrResult === void 0) {
      ssrResult = false;
    }
    if (MiscUtils.isServer) {
      return ssrResult;
    }
    var queryString = "(".concat(query, ": ").concat(value, "px)");
    return window.matchMedia(queryString).matches;
  };
  MiscUtils.clone = function (obj) {
    return JSON.parse(JSON.stringify(obj));
  };
  MiscUtils.isNumber = function (x) {
    return typeof x === 'number';
  };
  MiscUtils.isString = function (x) {
    return typeof x === 'string';
  };
  MiscUtils.isBoolean = function (x) {
    return typeof x === 'boolean';
  };
  MiscUtils.isAdBlockEnabled = function () {
    return window.__ark_ads__ === undefined || typeof window.__ark_ads__.AdVideo !== 'function';
  };
  MiscUtils.getNowTimestampUTC = function () {
    return new Date().getTime();
  };
  MiscUtils.fixMissingLang = function (lang) {
    if (lang === 'es' || lang === 'de') {
      return 'en';
    }
    return lang;
  };
  MiscUtils.debounce = function (wrappedFunction, delayInMilliSeconds) {
    var _this = this;
    var debounceTimerId;
    return function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      clearTimeout(debounceTimerId);
      debounceTimerId = window.setTimeout(function () {
        wrappedFunction.apply(_this, args);
      }, delayInMilliSeconds);
    };
  };
  MiscUtils.loadableRetry = function (fn, _a) {
    var _b = _a === void 0 ? {} : _a,
      _c = _b.retries,
      retries = _c === void 0 ? 3 : _c,
      _d = _b.interval,
      interval = _d === void 0 ? 500 : _d,
      _e = _b.exponentialBackoff,
      exponentialBackoff = _e === void 0 ? true : _e;
    return new Promise(function (resolve, reject) {
      fn().then(resolve).catch(function (error) {
        setTimeout(function () {
          if (retries === 0) {
            reject(error);
            return;
          }
          // Passing on "reject" is the important part
          MiscUtils.loadableRetry(fn, {
            retries: retries - 1,
            interval: exponentialBackoff ? interval * 2 : interval
          }).then(resolve, reject);
        }, interval);
      });
    });
  };
  return MiscUtils;
}();
export { MiscUtils };